/** Same-ramp meter: the fill carries severity, the track is a lighter step of the same hue. */
export function BatteryMeter({ percentage, low }: { percentage?: number; low?: boolean }) {
  if (percentage === undefined) return <span className="muted">—</span>;
  const pct = Math.max(0, Math.min(100, percentage));
  const color = low || pct <= 20 ? 'var(--status-critical)' : pct <= 40 ? 'var(--status-warning)' : 'var(--status-good)';
  return (
    <span className="meter" style={{ '--meter-color': color } as React.CSSProperties} title={`${pct}% battery`}>
      <span className="meter__track" aria-hidden="true">
        <span className="meter__fill" style={{ width: `${pct}%` }} />
      </span>
      <span className="tabular small">{pct}%</span>
    </span>
  );
}
